export enum FavoritePageEnum {
    AGENTIC_WORKFLOWS = 'agentic-workflows',
    AI_GENERATED_CONTENT = 'ai-generated-content',
    BOUNCE_INTEL = 'bounceintel',
    DASHBOARD = 'dashboard',
    FORMS_INTEL = 'forms-intel',
    HUBSPOT_ENRICHMENT = 'enrichment',
    CUSTOM_ENRICHMENT = 'custom-enrichment',
    ICP_INTEL = 'icp-intel',
    INBOX_INTEL = 'inboxintel',
    LISTS = 'lists',
    PROSPECT_INTEL = 'search',
    REP_INTEL = 'rep-intel',
    RESEARCH_ON_DEMAND = 'rod',
    SAVED_SEARCHES = 'savedsearches',
    VISITOR_INTEL = 'visitorintel',
}

